<template>
	<div style="height: calc(100vh - 56px); overflow-y: scroll;">
		<div class="mx-auto mt-4" style="max-width: 1320px;">
			<div>
				<CCol>
					<clientFilter v-if="isSysAdmin || isGroupAdmin" class="" />
				</CCol>
			</div>
			<div>
				<CCol class="opp-table-wrapper">
					<CCard>
						<CCardHeader style="display: flex;gap: 8px;justify-content: flex-end;">
							<CButton color="danger" @click="clearFiltersHandler" style="margin-right: auto;">Clear
								Filters
							</CButton>
						</CCardHeader>
						<CCardBody>
							<CDataTable class="sticky-header-table" stickyHeader striped :items="oppTableData"
								:fields="OPP_TABLE_COLUMNS" :column-filter="true" tableFilter theadTopSlot=""
								itemsPerPageSelect :itemsPerPage="5" pagination>
                                <template #project_id-filter="{ item }">
                                    Project Number
                                </template>
								<template #action="{ item }">
									<td>
										<div style="width: max-content;">
										<CLink style="cursor: pointer;" @click="exploreClickHandler(item, 'Explore')">
											Explore
										</CLink> |
										<CLink style="cursor: pointer;" @click="exploreClickHandler(item, 'Defer')">
											Defer
										</CLink> |
										<CLink style="cursor: pointer;"
											@click="exploreClickHandler(item, 'Participate')">
											Participate
										</CLink> |
										<CLink style="cursor: pointer;"
										@click="exploreClickHandler(item, 'Complete')">
											Complete
										</CLink>
									</div>
									</td>
								</template>
								<template #client_name-filter="{ item }">
									<CDropdown color="primary" toggler-text="Client" class="filter-button"
										:class="{ filtered: isFilteredClients }">
										<div class="px-3 py-1" style="width: max-content;">
											<!-- <div class="d-flex justify-content-start"
												style="font-weight: 500; margin-bottom: 10px;">
												<CLink @click="handleCheckAll('client')"> Check All </CLink>&nbsp;
												|&nbsp;
												<CLink @click="handleUnCheckAll('client')"> Uncheck All </CLink>
											</div> -->
											<CInputCheckbox v-for="client in clients" v-bind:key="client.value"
												:value="client.value" v-if="client.visible" :label="client.value"
												:checked.sync="client.checked" @update:checked="handleCheckboxUpdate" />
										</div>
									</CDropdown>
								</template>
								<template #opportunity_group-filter="{ item }">
									<CDropdown color="primary" toggler-text="Group" class="filter-button"
										:class="{ filtered: isFilteredGroups }">
										<div class="px-3 py-1"
											style="width: max-content; max-height: 200px; overflow: auto;">
											<!-- <div class="d-flex justify-content-start"
												style="font-weight: 500; margin-bottom: 10px;">
												<CLink @click="handleCheckAll('group')"> Check All </CLink>&nbsp;
												|&nbsp;
												<CLink @click="handleUnCheckAll('group')"> Uncheck All </CLink>
											</div> -->
											<CInputCheckbox v-for="group in groups" v-bind:key="group.value"
												:value="group.value" v-if="group.visible" :label="group.value"
												:checked.sync="group.checked" @update:checked="handleCheckboxUpdate" />
										</div>
									</CDropdown>
								</template>
								<template #opportunity_set_status-filter="{ item }">
									<CDropdown color="primary" toggler-text="Status" class="filter-button"
										:class="{ filtered: isFilteredStatuses }">
										<div class="px-3 py-1" style="width: max-content;">
											<!-- <div class="d-flex justify-content-start"
												style="font-weight: 500; margin-bottom: 10px;">
												<CLink @click="handleCheckAll('status')"> Check All </CLink>&nbsp;
												|&nbsp;
												<CLink @click="handleUnCheckAll('status')"> Uncheck All </CLink>
											</div> -->
											<CInputCheckbox v-for="status in statuses" v-bind:key="status.value"
												:value="status.value" v-if="status.visible" :label="status.value"
												:checked.sync="status.checked" @update:checked="handleCheckboxUpdate" />
										</div>
									</CDropdown>
								</template>
								<template #opportunity_category-filter="{ item }">
									Category
								</template>
								<template #sku_count-filter="{ item }">
									SKUs
								</template>
								<template #total_spend-filter="{ item }">
									Spend
								</template>
								<template #potential_savings-filter="{ item }">
									Opportunity
								</template>
								<template #savings_percent-filter="{ item }">
									%
								</template>
								<template #action-filter="{ item }">
									Action
								</template>
							</CDataTable>
						</CCardBody>
					</CCard>
				</CCol>

				<CElementCover v-if="spinner" :opacity="0.8" />
			</div>
		</div>
	</div>
</template>

<script>
import _ from "../Utility/utility";
import gql from "graphql-tag";
import clientFilter from "../../components/clientFilter";
import store, { storeData } from "../../store";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import "vue-multiselect/dist/vue-multiselect.min.css";
import { getSelectedClients } from "../../store";

export default {
	components: {
		clientFilter,
		vSelect,
	},
	data() {
		return {
			OPP_TABLE_COLUMNS: [
            { key: "project_id", label: "Project Number", filter: true },
				{ key: "client_name", label: "Client", filter: true },
				{ key: "opportunity_group", label: "Group", filter: true },
				{
					key: "opportunity_category", label: "Category", filter: true
				},
				{
					key: "sku_count", label: "SKUs",
					sorter: false, filter: true
				},
				{
					key: "total_spend", label: "Spend", filter: true
				},
				{ key: "opportunity_set_status", label: "Status", filter: true },
				{
					key: "potential_savings", label: "Opportunity", filter: true
				},
				{
					key: "savings_percent", label: "%", filter: true
				},
				{
					key: "action", label: "Action", filter: true
				},
			],
			rawData: [],
			oppTableData: [],
			spinner: false,
			clients: [],
			groups: [],
			statuses: [],
			selectedFilterClients: [],
			selectedFilterGroups: [],
			selectedFitlerStatuses: [],
		};
	},
	computed: {
		isSysAdmin() {
			return storeData.currentUserDetails.role.name === "sys_admin";
		},
		isGroupAdmin() {
			return storeData.currentUserDetails.role.name === "group_admin";
		},
		selectedClients() {
			return getSelectedClients();
		},
		isFilteredClients() {
			return !this.clients.every(c => c.checked);
		},
		isFilteredGroups() {
			return !this.groups.every(g => g.checked);
		},
		isFilteredStatuses() {
			return !this.statuses.every(s => s.checked);
		}
	},
	watch: {
		async selectedClients() {
			this.spinner = true;
			await this.fetchOppTableData();
			this.spinner = false;
		}
	},
	methods: {
		handleCheckboxUpdate() {
			const checkedClientsValues = this.clients.filter(c => c.checked).map(c => c.value);
			const checkedGroupsValues = this.groups.filter(g => g.checked).map(g => g.value);
			const checkedStatusesValues = this.statuses.filter(s => s.checked).map(s => s.value);
			let tempResultData;

			// get group filter list
			tempResultData = this.rawData.filter(row => {
				if (checkedClientsValues.length === 0 || checkedClientsValues.indexOf(row.client_name) > -1 &&
					checkedStatusesValues.length === 0 || checkedStatusesValues.indexOf(row.opportunity_set_status) > -1) {
					return true;
				}
				return false;
			});
			const tempGroups = tempResultData.map(d => d.opportunity_group);
			this.groups = this.groups.map(g => tempGroups.indexOf(g.value) > -1 ? ({ ...g, visible: true }) : ({ ...g, visible: false }));

			// get status filter list
			tempResultData = this.rawData.filter(row => {
				if (checkedClientsValues.length === 0 || checkedClientsValues.indexOf(row.client_name) > -1 &&
					checkedGroupsValues.length === 0 || checkedGroupsValues.indexOf(row.opportunity_group) > -1) {
					return true;
				}
				return false;
			});
			const tempOpps = tempResultData.map(d => d.opportunity_set_status);
			this.statuses = this.statuses.map(s => tempOpps.indexOf(s.value) > -1 ? ({ ...s, visible: true }) : ({ ...s, visible: false }));

			// get client filter list
			tempResultData = this.rawData.filter(row => {
				if (checkedStatusesValues.length === 0 || checkedStatusesValues.indexOf(row.opportunity_set_status) > -1 &&
					checkedGroupsValues.length === 0 || checkedGroupsValues.indexOf(row.opportunity_group) > -1) {
					return true;
				}
				return false;
			});
			const tempClients = tempResultData.map(d => d.client_name);
			this.clients = this.clients.map(c => tempClients.indexOf(c.value) > -1 ? ({ ...c, visible: true }) : ({ ...c, visible: false }));

			this.oppTableData = this.rawData.filter(row => {
				if ((checkedClientsValues.length === 0 || checkedClientsValues.indexOf(row.client_name) > -1) &&
					(checkedGroupsValues.length === 0 || checkedGroupsValues.indexOf(row.opportunity_group) > -1) &&
					(checkedStatusesValues.length === 0 || checkedStatusesValues.indexOf(row.opportunity_set_status) > -1)) {
					return true;
				}
				return false;
			});
		},
		clearFiltersHandler() {
			this.clients = this.clients.map(c => ({ ...c, checked: true, visible: true }));
			this.groups = this.groups.map(g => ({ ...g, checked: true, visible: true }));
			this.statuses = this.statuses.map(s => ({ ...s, checked: true, visible: true }));

			this.oppTableData = this.rawData;
		},
		async exploreClickHandler(item, newStatus) {
			this.spinner = true;
			await this.$apollo
				.mutate({
					mutation: UPDATE_OPPORTUNITY_SET_STATUS,
					variables: {
						opportunity_set_status: newStatus,
						opportunity_id: item.opportunity_id
					},
				})
				.then((res) => {
				}).catch((err) => {
					console.log(err);
				});

			await this.fetchOppTableData();
			this.spinner = false;
		},
		async fetchOppTableData() {
			await this.$apollo
				.mutate({
					mutation: GET_OPPORTUNITY,
					variables: {
						clients: this.selectedClients,
					},
				})
				.then((res) => {
					const tableRows = res.data.spendmd_db_total_opportunity_aggregate.nodes.map((row) => {
						return ({ ...row, action: "actions placeholder" })
					});
					this.rawData = tableRows;
					this.oppTableData = tableRows;

					const tempClients = tableRows.map(row => row.client_name);
					this.clients = [...new Set(tempClients)].map(row => ({ label: row, value: row, checked: true, visible: true }));

					const tempGroups = tableRows.map(row => row.opportunity_group);
					this.groups = [...new Set(tempGroups)].map(row => ({ label: row, value: row, checked: true, visible: true }));

					const tempStatuses = tableRows.map(row => row.opportunity_set_status).filter(item => !!item);
					this.statuses = [...new Set(tempStatuses)].map(row => ({ label: row, value: row, checked: true, visible: true }));
				}).catch((err) => {
					console.log(err);
				});
		},
		handleFilterSelect() {
			const selectedFilterClientsValues = this.selectedFilterClients.map(item => item.value);
			const selectedFilterGroupsValues = this.selectedFilterGroups.map(item => item.value);
			const selectedFitlerStatusesValues = this.selectedFitlerStatuses.map(item => item.value);

			this.oppTableData = this.rawData.filter(row => {
				if ((selectedFilterClientsValues.length === 0 || selectedFilterClientsValues.indexOf(row.client_name) > -1) &&
					(selectedFilterGroupsValues.length === 0 || selectedFilterGroupsValues.indexOf(row.opportunity_group) > -1) &&
					(selectedFitlerStatusesValues.length === 0 || selectedFitlerStatusesValues.indexOf(row.opportunity_set_status) > -1)) {
					return true;
				}
				return false;
			})
		},
	},
	async mounted() {
		if (!this.isSysAdmin && !this.isGroupAdmin) {
			this.OPP_TABLE_COLUMNS = this.OPP_TABLE_COLUMNS.filter(item => item.key !== "client_name");
		}

		this.spinner = true;
		await this.fetchOppTableData();
		this.spinner = false;

	}
};

const GET_OPPORTUNITY = gql`
	query (
		$clients: json
	) {
		spendmd_db_total_opportunity_aggregate(
			args: {
				clients: $clients
			}
		) {
			nodes {
                project_id
				client_name
				opportunity_id
				opportunity_group
				opportunity_category
				total_spend
				sku_count
				potential_savings
				savings_percent
				opportunity_set_status
			}
			aggregate {
				sum {
					sum_total_spend: total_spend
					sum_potential_savings: potential_savings
				}
			}
		}
	}
`;

const UPDATE_OPPORTUNITY_SET_STATUS = gql`
    mutation (
        $opportunity_set_status: String!
        $opportunity_id: Int!
    ) {
        update_spendmd_db_opportunity_test(
            _set: {
                opportunity_set_status: $opportunity_set_status
            }
            where: { id: { _eq: $opportunity_id } }
        ) {
            returning {
             id
            }
        }
    }
`;
</script>

<style scoped>
.header-cell {
	display: flex;
	justify-content: center;
}
.opp-table-wrapper {
	text-align: center;
}

.sticky-header-table::v-deep>.table-responsive {
	min-height: 300px;
	height: 420px;
	overflow-y: auto;
	position: inherit;
}

.sticky-header-table::v-deep table>thead {
	position: sticky;
	top: 0;
	z-index: 1;
}

.sticky-header-table::v-deep table>thead>tr>th {
	padding: 0;
	border: none;
	background-color: white;
}

.opp-table-wrapper .sticky-header-table>div {
	height: unset;
}

.sticky-header-table::v-deep table>thead>tr:first-child {
	display: none;
}

.sticky-header-table::v-deep table>thead>tr:last-child>th {
	vertical-align: middle;
	padding: 0;
	height: 50px;
}

.sticky-header-table::v-deep table>thead>tr:last-child>th button.dropdown-toggle {
	width: 100%;
	text-align: end;
	border: none;
	box-shadow: none !important;
	border-radius: 0;
	background: transparent !important;
	color: rgb(60, 75, 100);
	font-weight: 700;
}

.sticky-header-table::v-deep table>thead>tr>th button {
	display: flex;
	align-items: center;
	justify-content: center;
}

.sticky-header-table::v-deep table>thead>tr>th {
	text-align: center;
}

.filter-button.dropdown.filtered::v-deep>button::after {
	content: "\f0b0";
	vertical-align: middle;
	border: none;
	font: normal normal normal 16px / 1 FontAwesome;
	padding-left: 4px;
}
</style>
